import { z } from 'zod';

const contactFormSchema = z.object({
  contactFirstName: z
    .string()
    .min(1, { message: 'component.form.error.required' }),
  contactLastName: z
    .string()
    .min(1, { message: 'component.form.error.required' }),
  contactEmailAddress: z
    .string()
    .min(1, { message: 'component.form.error.required' })
    .email({ message: 'component.form.error.contactEmailAddress' }),
  contactTelephoneNumber: z.string(),
  // .min(1, { message: 'component.form.error.required' }),
  contactMessage: z
    .string()
    .min(1, { message: 'component.form.error.required' }),
});

export type TContactForm = z.infer<typeof contactFormSchema>;

export { contactFormSchema };
